module.exports = __webpack_public_path__ + "static/media/Right Lateral Z2.bef2aefa.png";